import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import VariableValueForm from "../types/VariableValueForm";

export const CustomerAgeForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "currency",
    prefix: "",
    suffix: " ano(s)",
    precision: 0,
    min: 0,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerAge}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <VariableValueForm
        node={node}
        disableTimeRange
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
